import React, { useMemo } from 'react'

import { observer } from 'mobx-react'

import { IWorkflowTypeAction } from '~/client/src/shared/models/WorkflowType'

import WorkflowStepConfiguratorStore from '../WorkflowStepConfigurator.store'
import AddActionButton from './components/AddActionButton'
import WorkflowAction from './components/WorkflowAction'
import WorkflowActionConfiguratorStore from './WorkflowActionConfigurator.store'

interface IProps {
  stepsConfiguratorStore: WorkflowStepConfiguratorStore
  stepId: string
  onActionsChange(actions: IWorkflowTypeAction[]): void
  actions: IWorkflowTypeAction[]
}

function WorkflowActionConfigurator(props: IProps) {
  const { stepsConfiguratorStore, stepId, actions = [] } = props

  const handleChangeActions = (newActions: IWorkflowTypeAction[]) => {
    props.onActionsChange(newActions)
  }

  const store = useMemo(() => {
    const newStore = new WorkflowActionConfiguratorStore(handleChangeActions)
    newStore.initialize(stepsConfiguratorStore, stepId)
    return newStore
  }, [stepsConfiguratorStore, stepId])

  return (
    <div className="col">
      {actions.map((action, index) => (
        <WorkflowAction
          key={`step-${stepId}-action-${index}`}
          stepId={stepId}
          stepsConfiguratorStore={stepsConfiguratorStore}
          store={store}
          action={action}
          actionIndex={index}
        />
      ))}
      <AddActionButton onAddAction={store.createAction} store={store} />
    </div>
  )
}

export default observer(WorkflowActionConfigurator)
